import * as R from 'ramda';
import { combineReducers } from 'redux';

import * as ActionTypes from '../../actions/ActionTypes';
import { isType } from '../../utils/ActionUtils';
import { DEFAULT_VIDEO_ID } from '../../constants';


export const currentTimeReducer = (state = 0, action) => R.cond([
    [ isType(ActionTypes.SET_CURRENT_TIME_STATE), R.prop('payload') ],
    [ R.T, R.always(state) ]
])(action);


export const durationReducer = (state = false, action) => R.cond([
    [ isType(ActionTypes.SET_DURATION_STATE), R.prop('payload') ],
    [ R.T, R.always(state) ]
])(action);


export const errorReducer = (state = false, action) => R.cond([
    [ isType(ActionTypes.SET_ERROR_STATE), R.prop('payload') ],
    [ R.T, R.always(state) ]
])(action);


export const firstTimeReducer = (state = null, action) => R.cond([
    [ isType(ActionTypes.SET_VIDEO_SOURCE), R.always(null) ],
    [ isType(ActionTypes.SET_FIRST_TIME_STATE), R.pipe(R.prop('payload'), parseInt) ],
    [ R.T, R.always(state) ]
])(action);


export const startedReducer = (state = null, action) => R.cond([
    [ isType(ActionTypes.SET_VIDEO_SOURCE), R.always(null) ],
    [ isType(ActionTypes.SET_STARTED_STATE), R.T ],
    [ R.T, R.always(state) ]
])(action);


export const muteReducer = (state = false, action) => R.cond([
    [ isType(ActionTypes.SET_MUTE_STATE), R.prop('payload') ],
    [ R.T, R.always(state) ]
])(action);


export const pauseReducer = (state = false, action) => R.cond([
    [ isType(ActionTypes.SET_PAUSE_STATE), R.prop('payload') ],
    [ R.T, R.always(state) ]
])(action);


export const playingReducer = (state = false, action) => R.cond([
    [ isType(ActionTypes.SET_PLAYING_STATE), R.prop('payload') ],
    [ isType(ActionTypes.PLAYER_EVENT_WAITING), R.F ],
    [ isType(ActionTypes.PLAYER_EVENT_PLAYING), R.T ],
    [ R.T, R.always(state) ]
])(action);


export const shareReducer = (state = false, action) => R.cond([
    [ isType(ActionTypes.ON_SHARE_CONTROL_CLICK), R.always(!state) ],
    [ isType(ActionTypes.ON_SHARE_CONTROL_CLOSE), R.F ],
    [ isType(ActionTypes.SET_VIDEO_SOURCE), R.F ],
    [ R.T, R.always(state) ]
])(action);


export const videoProgressReducer = (state = 0, action) => R.cond([
    [ isType(ActionTypes.SET_VIDEO_PROGRESS_STATE), R.prop('payload') ],
    [ isType(ActionTypes.SET_VIDEO_ID), R.always(0) ], // reset video fifty
    [ isType(ActionTypes.TRACK_VIDEO_COMPLETE), R.always(0) ], // reset video fifty
    [ R.T, R.always(state) ]
])(action);


export const videoFiftyReachedReducer = (state = false, action) => R.cond([
    [ isType(ActionTypes.TRACK_VIDEO_FIFTY), R.T ],
    [ isType(ActionTypes.SET_VIDEO_ID), R.F ], // reset video fifty
    [ R.T, R.always(state) ]
])(action);


export const videoIDReducer = (state = DEFAULT_VIDEO_ID, action) => R.cond([
    [ isType(ActionTypes.SET_VIDEO_ID) && R.pipe(R.prop('payload'), (volume) => R.not(R.is(String, volume))), R.always(state) ], // filter out non-strings
    [ isType(ActionTypes.SET_VIDEO_ID), R.prop('payload') ],
    [ R.T, R.always(state) ]
])(action);


export const volumeReducer = (state = 1, action) => R.cond([
    [ isType(ActionTypes.SET_VOLUME_STATE) && R.pipe(R.prop('payload'), (volume) => R.not(R.is(Number, volume))), R.always(state) ], // filter out non numbers
    [ isType(ActionTypes.SET_VOLUME_STATE), R.prop('payload') ],
    [ R.T, R.always(state) ]
])(action);


export const isVolumeDraggingReducer = (state = false, action) => R.cond([
    [ isType(ActionTypes.SET_VOLUME_DRAG_STATE), R.prop('payload') ],
    [ isType(ActionTypes.ON_VOLUME_SLIDER_MOUSE_DOWN), R.T ],
    [ R.T, R.always(state) ]
])(action);


export const isLiveReducer = (state = null, action) => R.cond([
    [isType(ActionTypes.SET_LIVE_STATE), R.prop('payload')],
    [R.T, R.always(state)]
])(action);


export const waitingReducer = (state = false, action) => R.cond([
    [ isType(ActionTypes.SET_WAITING_STATE), R.prop('payload') ],
    [ isType(ActionTypes.PLAYER_EVENT_WAITING), R.T ],
    [ isType(ActionTypes.PLAYER_EVENT_PLAYING), R.F ],
    [ R.T, R.always(state) ]
])(action);


export const adsEnabledReducer = (state = null, action) => R.cond([
    [ isType(ActionTypes.ENABLE_ADS), R.T ],
    [ isType(ActionTypes.DISABLE_ADS), R.F ],
    [R.T, R.always(state)]
])(action);


export const adPlayingReducer = (state = false, action) => R.cond([
    [ isType(ActionTypes.SET_AD_PLAYING_STATE), R.prop('payload') ],
    [ R.T, R.always(state) ]
])(action);


export const adRequestCompleteReducer = (state = null, action) => R.cond([
    [ isType(ActionTypes.SET_ADS_REQUEST_COMPLETE_STATE), R.prop('payload') ],
    [ isType(ActionTypes.SET_VIDEO_SOURCE), R.always(null) ],
    [ R.T, R.always(state) ]
])(action);


export const adReturnMidrollTimeReducer = (state = -1, action) => R.cond([
    [isType(ActionTypes.SET_ADS_RETURN_MIDROLL_TIME_STATE), R.prop('payload')],
    [isType(ActionTypes.SET_VIDEO_SOURCE), R.always(-1)],
    [R.T, R.always(state)]
])(action);


export const queryParamTimecodeSeekedReducer = (state = false, action) => R.cond([
    [isType(ActionTypes.SET_QUERY_PARAM_TIMECODE_SEEKED_STATE), R.prop('payload')],
    [R.T, R.always(state)]
])(action);


export default combineReducers({
    adPlaying: adPlayingReducer,
    adRequestComplete: adRequestCompleteReducer,
    adReturnMidrollTime: adReturnMidrollTimeReducer,
    adsEnabled: adsEnabledReducer,
    currentTime: currentTimeReducer,
    duration: durationReducer,
    error: errorReducer,
    firstTime: firstTimeReducer,
    isLive: isLiveReducer,
    isVolumeDragging: isVolumeDraggingReducer,
    muted: muteReducer,
    pause: pauseReducer,
    playing: playingReducer,
    queryParamTimecodeSeeked: queryParamTimecodeSeekedReducer,
    share: shareReducer,
    started: startedReducer,
    videoFiftyReached: videoFiftyReachedReducer,
    videoID: videoIDReducer,
    videoProgress: videoProgressReducer,
    volume: volumeReducer,
    waiting: waitingReducer,
});


// WEBPACK FOOTER //
// ./src/player/state/reducer.js